export const dataUser = [
  {
    id: 1,
    name: "Yos Sularko",
    email: "yossularko@dev.com",
    role: "Engineer",
    password: "21232123",
  },
  {
    id: 2,
    name: "Administrator",
    email: "admin@dev.com",
    role: "Admin",
    password: "admin123",
  },
];
